export default __webpack_public_path__ + "static/media/ESP1.2a2f0582.png";